module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "striped"
  }, [_c('thead', [_c('th', [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Clear Selection"
    },
    on: {
      "click": _vm.clearSelection
    }
  }, [_vm._v("clear")])]), _vm._v(" "), _c('th', [_vm._v("AEA Energy Region")]), _vm._v(" "), _c('th', [_vm._v("Data Category")]), _vm._v(" "), _c('th', [_vm._v("Data Availability")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.AEAEnergyRegionsForSelect), function(region) {
    return _c('tr', [_c('td', [_c('input', {
      staticClass: "filled-in",
      attrs: {
        "id": 'region_' + region.id,
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.AEAEnergyRegionChecked(region.id)
      },
      on: {
        "click": function($event) {
          return _vm.checkboxClick(region.id)
        }
      }
    }), _c('label', {
      attrs: {
        "for": 'region_' + region.id
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(region.name))]), _vm._v(" "), _c('td', {
      staticClass: "center_cell"
    }, [_vm._v(_vm._s(_vm.selectedMetricCategory.display.split(' ')[0]))]), _vm._v(" "), _c('td', {
      staticClass: "center_cell"
    }, [_c('data-availability-indicator', {
      attrs: {
        "score": region.score
      }
    })], 1)])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9cfb932"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AEAEnergyRegionList.vue
// module id = 151
// module chunks = 1